(function() {
  document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
      return html`
        <a
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          href="${algoliaShopify.helpers.instantsearchLink(hit)}"
          onclick="void(0)"
          title="${algoliaShopify.helpers.fullTitle(
            hit.title,
            hit._distinct,
            hit.variant_title
          )}"
        >
          <div
            class="ais-hit ais-product"
            data-algolia-index="${hit.index}"
            data-algolia-position="${hit.productPosition}"
            data-algolia-queryid="${hit.queryID}"
            data-algolia-objectid="${hit.objectID}"
            data-handle="${hit.handle}"
            data-variant-id="${hit.objectID}"
            data-distinct="${hit._distinct}"
            data-product-id="${hit.id}"
          >
            <img
              class="ais-hit--picture"
              src="${algoliaShopify.helpers.largeImage(hit)}"
              alt="${hit.title} - ${hit.variant_title}"
            />
          </div>
          <div class="ais-hit--details">
            <p class="ais-hit--subtitle" title="${hit.product_type} by ${hit.sku}">
              <span class="algolia-sku">${hit.sku}</span>
            </p>
            <div class="ais-hit--container">
              <p class="ais-hit--title">${hit.title}</p>
              <p class="ais-hit--variant">${hit.variant_title}</p>
            </div>
            <p class="ais-hit--price">
              <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
              ${!hit._distinct &&
                html`
                  <span class="ais-hit--price-striked"
                    ><span
                      >${algoliaShopify.helpers.displayStrikedPrice(
                        hit.price,
                        hit.compare_at_price
                      )}</span
                    ></span
                  >
                `}
              ${!hit._distinct &&
                html`
                  <span class="ais-hit--price-discount"
                    >${algoliaShopify.helpers.displayDiscount(
                      hit.price,
                      hit.compare_at_price,
                      hit.price_ratio
                    )}</span
                  >
                `}
            </p>
          </div>
        </a>
      `;
    });
  });
})();
